import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Modal, Typography, Select, message,Tag } from 'antd';
import { SearchOutlined, ToolFilled } from '@ant-design/icons';
import { hnrequest } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const { Paragraph, Text } = Typography;
const { TextArea } = Input;
const Dbhf = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [pgglis, setpgglis] = useState([]);// 选择的产品信息


  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/pms_list')
      setbangm(res.rescode)
    }
    getau()
  }, [])

  const gohf = async (v) => {
    const res = await hnrequest.post('/pgg_list', v)
    if (res.return_code === 'success') {
      setccpxx(v)
      setpgglis(res.rescode)
      formxf.setFieldsValue({ p_no: v.key, p_gg: '', xfjson: '' });// 回传发送短信订单号码
      setOpen(true)


    }
  }

  const onFxfsq = async (e) => {
    const rq = await hnrequest.post('/xfsq', e)
    setOpen(false)
    messageApi.open({type: rq.return_code,content: rq.return_msg,});
  }







  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [

    {
      title: '产品编号',
      dataIndex: 'key',
      key: 'key',
      ...getColumnSearchProps('key'),
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '产品类别',
      key: 'dblx',
      ...getColumnSearchProps('dblx'),
      dataIndex: 'dblx',
      render: (_, record) => (
        <Space size="middle">
          {record.dblx === "1001" && <Tag color="volcano" >农药</Tag>}
          {record.dblx === "1003" && <Tag color="green" >种子</Tag>}
          {record.dblx === "1002" && <Tag color="purple" >农肥&其他</Tag>}
          {record.dblx === "1004" && <Tag color="purple" >农肥&其他</Tag>}
        </Space>
      ),
    },
    {
      title: '名称',
      dataIndex: 'pname',
      key: 'pname',
      ...getColumnSearchProps('pname'),
    },
    {
      title: '农药登记证',
      key: 'nydjz',
      ...getColumnSearchProps('nydjz'),
      dataIndex: 'nydjz',
    },
    {
      title: '备注',
      key: 'tags',
      ...getColumnSearchProps('tags'),
      dataIndex: 'tags',
    },
    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button color="cyan" variant="solid" icon={<ToolFilled />} id={record.key}
            onClick={() => gohf(record)}
          >选中修复</Button>
        </Space>
      ),
    },
  ];


  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <div >
          <Form form={form} component={false}>

            <Table
              // rowSelection={   {type:"checkbox",...rowSelection,}} 
              columns={columns} dataSource={bangm} />

          </Form>



        </div>


        <Modal
          // title="数据修复申请表"
          footer={null}
          centered
          open={open}
          onOk={() => onFxfsq()}
          onCancel={() => setOpen(false)}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          <Paragraph>产品名称：{ccpxx.pname}  <Text>产品编号：{ccpxx.key}</Text> </Paragraph>

          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >

            <Form.Item name='p_no' hidden={true}>
              <Input />
            </Form.Item>
            <Form.Item name='p_gg' label="选择规格" rules={[{ required: true, message: '请选择规格!' },]}  >
              <Select options={pgglis} />
            </Form.Item>


            <Form.Item label="修复字段" name='xfjson' rules={[{ required: true, message: '请填写修复字段!' },]}>
              <TextArea rows={2} />
            </Form.Item>
            <Paragraph type="danger">* 该服务接入需20元服务费及至少10000的胜券余额请保证余额足够，被恢复产品将冻结修改，同时胜券余额不足将暂停修复。修复费用为1胜券等价0.01元/条（不重复计费）。 </Paragraph>
            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                block={true} >
                发   起   审  请
              </Button>
            </Form.Item>


          </Form>
        </Modal>



      </ConfigProvider>
    </>

  );
};
export default Dbhf;